import React from 'react';
import { Create, List, Datagrid, TextField,   Edit,SimpleForm,DisabledInput, Toolbar, SaveButton, DeleteButton  } from 'react-admin';
import {  DateField, TextInput, EmailField ,    BooleanInput, BooleanField} from 'react-admin';

import {   EditButton } from 'react-admin';

import { ImageInput, ImageField } from 'react-admin';

import UserPhoto from '../utils/UserPhoto.js';

const styles = {
    flex: { display: 'flex'  },
};

const DeleteUserButton = ({ record }) => 
     record && record.id !== "1"  ? (
            <DeleteButton record={record} resource="users" />
        ) : null;

export const UserList = props => (
    <List {...props} bulkActionButtons={false} >
        <Datagrid  >
            <EditButton />
            <TextField source="id" />
            <TextField source="name" />
            <EmailField source="email" />
            <TextField source="type" />
            <DateField source="created_at" />
            <BooleanField source="active" />
            <DeleteUserButton />
        </Datagrid>
    </List>
);

const PostEditToolbar = props => (
    <Toolbar {...props} >
        <SaveButton />  
    </Toolbar>
);
///

const redirect = (basePath, id, data) => `/`;

/// in src/Users.js 
export const UserEditAdmin = props => (
    <Edit title={<UserTitle />} {...props}  >
        <SimpleForm validate={validateUserCreation}  redirect="list" toolbar={<PostEditToolbar />} >
           <DisabledInput source="id" />
           <TextInput source="name" fullWidth /> 
           <DisabledInput source="email" fullWidth />
           <DisabledInput source="type"  fullWidth />
           <DisabledInput source="client"  fullWidth />
           <TextInput source="password" type="password" />   
        </SimpleForm>
    </Edit>
);
export const UserEdit = props => (
    <Edit title={<ChangeAvatarTitle />} {...props} >
        <SimpleForm validate={validateUserCreation} toolbar={<PostEditToolbar />} redirect={redirect} >
           <UserPhoto />
            <div  style={styles.flex} fullWidth >
                <DisabledInput source="id" fullWidth  /> 
            </div>
            <ImageInput source="photo" multiple={false} autoFocus  >
                <ImageField source="src"   />
            </ImageInput>
        </SimpleForm>
    </Edit>
);
///
const ChangeAvatarTitle = ({ record }) => {
    return <span>Change Avatar User: {record ? `"${record.name}"` : ''}</span>;
};

///
export const UserCreate = props => (
    <Create {...props}>
        <SimpleForm validate={validateUserCreation} redirect="list" >
           <DisabledInput source="id" />
           <TextInput source="name" fullWidth  /> 
           <TextInput source="email" fullWidth />
           <DisabledInput  source="type" defaultValue={"admin"} /> 
           
            <TextInput source="password" type="password" />   
            <BooleanInput source="active" defaultValue={true} />         
        </SimpleForm>
    </Create>
);

/////
const  validateEmail = (email) => {
  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

//
const validateUserCreation = (values) => {
    const errors = {};
    if (!values.name) {
        errors.name = ['The name is required'];
    }
    if (!values.email) {
        errors.email = ['The email is required'];
    }
    if (!values.type) {
        errors.type = ['The type is required'];
    }
    if (!values.clientId) {
        errors.clientId = ['The clientId is required'];
    }
    if (!values.password) {
        errors.password = ['The password is required'];
    }
    if ( !validateEmail(values.email) ){
        errors.email = ['The email is invalid'];
    }
    return errors
};

const UserTitle = ({ record }) => {
    return <span>User: {record ? `"${record.name}"` : ''}</span>;
};
